import { type FC, useState } from "react";
import { Form } from "react-bootstrap";
import { Modal, useModal } from "../../common/modal/Modal";

interface ModalSaveAsTemplateProps {
	onSave: (data: { name: string; description: string }) => Promise<void>;
}

export const ModalSaveAsTemplate: FC<ModalSaveAsTemplateProps> = ({
	onSave,
}) => {
	const { close } = useModal();
	const [name, setName] = useState("");
	const [description, setDescription] = useState("");
	const [submitting, setSubmitting] = useState(false);

	const handleSubmit = async () => {
		if (!name.trim()) return;
		setSubmitting(true);
		try {
			await onSave({ name: name.trim(), description: description.trim() });
			close();
		} finally {
			setSubmitting(false);
		}
	};

	return (
		<Modal>
			<h5>Save as Campaign Template</h5>
			<p className="text-muted">
				Save the current campaign settings as a reusable template.
			</p>

			<Form.Group className="mb-3">
				<Form.Label>Template Name</Form.Label>
				<Form.Control
					value={name}
					onChange={(e) => setName(e.target.value)}
					placeholder="e.g. Holiday Traffic Campaign"
				/>
			</Form.Group>

			<Form.Group className="mb-3">
				<Form.Label>Description (optional)</Form.Label>
				<Form.Control
					as="textarea"
					rows={2}
					value={description}
					onChange={(e) => setDescription(e.target.value)}
					placeholder="Brief description of when to use this template"
				/>
			</Form.Group>

			<div className="d-flex gap-2">
				<button
					type="button"
					className="btn btn-primary flex-grow-1"
					disabled={submitting || !name.trim()}
					onClick={handleSubmit}
				>
					{submitting ? "Saving..." : "Save Template"}
				</button>
				<button
					type="button"
					className="btn btn-outline-secondary"
					onClick={close}
				>
					Cancel
				</button>
			</div>
		</Modal>
	);
};
